var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainLogoClubMila(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 13,
    viewBox: "0 0 180 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10003_2799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.177246H6.74965V2.38292H2.47719V5.30491H5.87985V7.51058H2.47719V10.617H6.74965V12.8155H0V0.177246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90674 0.177246H11.3839V10.617H15.4616V12.8155H8.90674V0.177246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1118 9.34752V3.64539C21.1118 1.29787 22.42 0 24.758 0C27.096 0 28.3903 1.29787 28.3903 3.64539V4.56738H26.0523V3.55319C26.0523 2.63121 25.6069 2.12766 24.8137 2.12766C24.0343 2.12766 23.589 2.63121 23.589 3.55319V9.43972C23.589 10.3617 24.0343 10.8652 24.8137 10.8652C25.6139 10.8652 26.0523 10.3617 26.0523 9.43972V8.07092H28.3903V9.35461C28.3903 11.7021 27.096 13 24.758 13C22.42 13 21.1118 11.695 21.1118 9.34752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.603 0.177246H33.0802V10.617H37.1509V12.8155H30.603V0.177246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0505 9.34745V0.184326H41.5277V9.49638C41.5277 10.3616 41.9522 10.7943 42.7872 10.7943C43.6222 10.7943 44.0467 10.3616 44.0467 9.49638V0.184326H46.4404V9.35454C46.4404 11.6453 45.167 12.9999 42.7385 12.9999C40.303 12.9999 39.0505 11.6453 39.0505 9.34745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9314 0.177246H52.6681C55.1453 0.177246 56.3351 1.19143 56.3351 3.33327V3.56732C56.3351 4.86519 55.8202 5.68079 54.7417 6.07796V6.13469C56.0011 6.54604 56.5856 7.50349 56.5856 9.11342V9.33327C56.5856 11.695 55.3958 12.8155 52.9046 12.8155H48.9384V0.177246H48.9314ZM52.3688 5.2198C53.3987 5.2198 53.8579 4.80845 53.8579 3.88647V3.64533C53.8579 2.75881 53.4822 2.38292 52.5985 2.38292H51.4155V5.2198H52.3688ZM52.8977 10.617C53.7466 10.617 54.1015 10.2411 54.1015 9.33327V8.99285C54.1015 7.82264 53.7118 7.42547 52.508 7.42547H51.4086V10.617H52.8977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.584 0.177246H66.3554C68.763 0.177246 70.0573 1.42547 70.0573 3.75171V9.24108C70.0573 11.5673 68.763 12.8155 66.3554 12.8155H62.584V0.177246ZM66.3206 10.617C67.2044 10.617 67.5801 10.2198 67.5801 9.28363V3.71625C67.5801 2.78008 67.2044 2.38292 66.3206 2.38292H65.0612V10.617H66.3206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4299 0.177246H79.1796V2.38292H74.9071V5.30491H78.3098V7.51058H74.9071V10.617H79.1796V12.8155H72.4299V0.177246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1638 0.177246H87.641V10.617H91.7186V12.8155H85.1638V0.177246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7258 10.5248H95.9424L95.5319 12.8155H93.1799L95.7476 0.177246H99.0946L101.662 12.8155H99.1294L98.7258 10.5248ZM98.3361 8.35455L97.3271 2.70207L96.3321 8.35455H98.3361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.459 0.177246H110.952L112.594 8.98576L114.222 0.177246H117.715V12.8155H115.377V3.41129L113.533 12.8155H111.46L109.623 3.41129V12.8155H107.459V0.177246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.774 0.177246H120.297V12.8155H122.774V0.177246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.363 0.177246H127.84V10.617H131.917V12.8155H125.363V0.177246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.932 10.5248H136.148L135.738 12.8155H133.386L135.953 0.177246H139.3L141.868 12.8155H139.335L138.932 10.5248ZM138.542 8.35455L137.533 2.70207L136.538 8.35455H138.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.837 0.177246H146.899L149.376 7.4893V0.177246H151.589V12.8155H149.091L146.05 3.82973V12.8155H143.837V0.177246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.177 0.177246H160.927V2.38292H156.654V5.30491H160.057V7.51058H156.654V10.617H160.927V12.8155H154.177V0.177246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.715 9.53192V8.97163H165.053V9.53192C165.053 10.3121 165.443 10.8652 166.327 10.8652C167.106 10.8652 167.621 10.3759 167.621 9.53192C167.621 8.44681 167.197 8.17731 165.513 7.34752C163.39 6.29787 162.764 5.21986 162.764 3.44681C162.764 1.39007 164.037 0 166.431 0C168.825 0 170.008 1.39007 170.008 3.48227V3.84397H167.67V3.50355C167.67 2.70922 167.315 2.13475 166.445 2.13475C165.687 2.13475 165.241 2.6383 165.241 3.41844C165.241 4.39716 165.721 4.68085 167.384 5.49645C169.562 6.56028 170.091 7.68085 170.091 9.48936C170.091 11.617 168.783 13.0071 166.355 13.0071C163.926 13.0071 162.715 11.6099 162.715 9.53192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.057 10.5248H174.273L173.863 12.8155H171.511L174.078 0.177246H177.425L179.993 12.8155H177.46L177.057 10.5248ZM176.667 8.35455L175.658 2.70207L174.67 8.35455H176.667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10003_2799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogoClubMila);
export default __webpack_public_path__ + "static/media/main-logo-club-mila.b65e680da05379720b62c7fb8c0d1bd2.svg";
export { ForwardRef as ReactComponent };